module.exports = __webpack_public_path__ + "img/skip-end-circle-fill.011be9c0.svg";